import { useLayoutEffect, useRef, useState } from 'react';

const useTitleWrapDetection = (isEnabled: boolean, titleName: string) => {
  const titleNameRef = useRef<HTMLSpanElement>(null);
  const [isTitleNameWrapped, setIsTitleNameWrapped] = useState(false);

  useLayoutEffect(() => {
    if (!isEnabled) {
      setIsTitleNameWrapped(false);
      return;
    }

    const titleNameElement = titleNameRef.current;
    if (!titleNameElement) return;

    const measureTitleWrap = () => {
      setIsTitleNameWrapped(titleNameElement.getClientRects().length > 1);
    };

    measureTitleWrap();

    const resizeObserver = new ResizeObserver(measureTitleWrap);
    resizeObserver.observe(titleNameElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [isEnabled, titleName]);

  return {
    isTitleNameWrapped,
    titleNameRef,
  };
};

export default useTitleWrapDetection;
